import { DataTables } from 'pages/Home/ModalReport/component/Table';
import { TableHeaderLabel } from 'pages/Home/ModalReport/component/Table/TableHead';
import { OptionItem } from 'pages/Home/ModalSettingReport';

export interface ReportConfig {
  page: number;
  years?: OptionItem[];
  topicId: OptionItem;
  variableIds: OptionItem[];
  dataShow: string[];
}
export interface DetailReport{
  baseYear: number,
  startYear: number,
  endYear: number,
  countryName: string,
  pages: DataReportPage[],
}

export interface DataTableReport{
  tableHeaders: TableHeaderLabel[],
  dataTables: DataTables[]
}

export interface DataChart{
  variableId: number;
  title: string,
  isPercentage: boolean,
  dataTablesBaseCase?: [number, number][],
  dataTablesScenario?: [number, number][],
  options?: Highcharts.Options
}
export enum ETYPE_PAGE_REPORT{
  COVER_PAGE,
  INTRODUCE_PAGE,
  DATA_PAGE
}
export interface DataReportPage{
  name: string,
  topic?: OptionItem,
  dataTable?: DataTableReport,
  dataChart?:DataChart[],
  type: ETYPE_PAGE_REPORT,
  page: number,
  charts?: Highcharts.Options[],
}

export enum ETYPE_SHOW{
  BASE = "BASE",
  SCENARIO="SCENARIO"
}
